import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

export const formatDate = (dayjsObj, format = "YYYY-MM-DD") => {
  return dayjsObj ? dayjs(dayjsObj).format(format) : dayjsObj;
};

export const convertToDayjs = (date, format) => {
  if (!date) return date;
  return format ? dayjs.utc(date, format) : dayjs.utc(date);
};

export const changeFormatDateTime = (date, format = "DD-MM-YYYY") => {
  if (!date) return "-";
  return dayjs.utc(date).format(format);
};
